import { useEffect } from 'react';

const UserWayWidget = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.setAttribute('data-account', '6m8Qm2laqO');
    script.src = 'https://cdn.userway.org/widget.js';

    // Optional: Set additional configurations by uncommenting and adjusting as needed
    script.setAttribute("data-position", 5);  // For example, set widget position
    // script.setAttribute("data-size", "small"); // Set widget size
    // script.setAttribute("data-language", "en"); // Set language
    // script.setAttribute("data-color", "#053e67"); // Custom color
    // script.setAttribute("data-type", "1"); // Widget icon type
    // script.setAttribute("data-mobile", true); // Enable mobile support

    document.body.appendChild(script);

    // Cleanup: Remove script if component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null; // No need to render any JSX; script loads the widget
};

export default UserWayWidget;
